import { requireNotNull } from "@whilecat/core/utils/validation.ts";
import type { paths } from "@whilecat/generated/openapi/java-compiler.ts";
import { getClient } from "@whilecat/services/client-utils.js";

const client = getClient<paths>();

export enum CodeType {
    CLASS = "CLASS",
    SCRIPT = "SCRIPT",
    TEST = "TEST",
}

type CodeTypeT = keyof typeof CodeType;

export type CodeRunResult = {
    output: string;
    result: "SUCCESS" | "ERROR" | "TIMEOUT";
    payload?: string | undefined;
};

export async function compileCode(
    codeSnippet: string,
    codeType: CodeTypeT,
): Promise<{
    response: Response;
    data: CodeRunResult | undefined;
}> {
    requireNotNull(codeSnippet, "code can't be null");
    requireNotNull(codeType, "code type can't be null");

    const payload = {
        type: codeType,
        code: codeSnippet,
    };
    const { response, data } = await client.POST("/java/run", { body: payload });

    return { response, data };
}
